import React from 'react'
import PropTypes from 'prop-types'
import { Field } from 'react-final-form'
import { withTheme } from 'react-jss'
import classNames from 'classnames'
import IntlTelInput from 'react-intl-tel-input'
import 'react-intl-tel-input/dist/main.css'
import './intlTelInputUtils'

import FormInput from 'components/form/form-input'

import { isInputWithError } from 'helpers/form'
import { formatToInternationalPhoneNumber } from 'helpers/phone-number'

import styles from 'components/form/form-style'

const PhoneInput = props => {
  const classes = styles(props.theme)

  return (
    <Field name={props.name}>
      {({ input, meta }) => (
        <FormInput label={props.label} meta={meta} input={input}>
          <IntlTelInput
            defaultValue={input.value}
            preferredCountries={['fr']}
            onPhoneNumberChange={(isValid, value, country) => input.onChange(formatToInternationalPhoneNumber(value, country.iso2))}
            onPhoneNumberBlur={input.onBlur}
            format={true}
            containerClassName={classNames(
              'intl-tel-input',
              classes.telInputBlock,
            )}
            inputClassName={classNames(
              classes.textInput,
              { [classes.inputWithError]: isInputWithError(meta) }
            )}
          />
          {props.children}
        </FormInput>
      )}
    </Field>
  )
}

PhoneInput.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  theme: PropTypes.object.isRequired,
  children: PropTypes.node
}

export default withTheme(PhoneInput)
